import { ESkillCategory } from "@/models/skill/category";

export function normalizedSkillDocumentTypes(skillDocumentTypes: number) {
  switch (skillDocumentTypes) {
    case 1:
      return "Групповой";
    case 2:
      return "Индивидуальный";
    default:
      "";
  }
}

export function normalizedEducationTypes(educationTypes: number) {
  switch (educationTypes) {
    case 1:
      return "Внешнее";
    case 2:
      return "Внутреннее";
    default:
      "";
  }
}

export function normalizedCategory(category: ESkillCategory) {
  switch (category) {
    case ESkillCategory.METHODICAL_ID:
      return "Методологический";
    case ESkillCategory.FUNCTIONAL_ID:
      return "Функциональный";
    case ESkillCategory.GENERAL_ID:
      return "Общий";
    case ESkillCategory.LEADERSHIP_ID:
      return "Лидерский";
    default:
      "";
  }
}
